<template>
	<div class="newsletter">
		<div class="content-newsletter">
			<div>
				<p
					:class="['content-topic', {'drc-topic' : newsletter.platform === PLATFORMS.DRC}, {'gop-topic' : newsletter.platform === PLATFORMS.GOP}]"
				>
					{{ newsletter.topic.trim() !== '' ? newsletter.topic : $t('controlPanel.landingPage.exampleTopic') }}
				</p>
				<p
					:class="['content-title', {'drc-title' : newsletter.platform === PLATFORMS.DRC}, {'gop-title' : newsletter.platform === PLATFORMS.GOP} ]"
				>
					{{ newsletter.title.trim() !== '' ? newsletter.title : $t('controlPanel.landingPage.exampleTitle') }}
				</p>
			</div>
			<div class="message">
				{{ newsletter.message.trim() !== '' ? newsletter.message : $t('controlPanel.landingPage.exampleMessage') }}
			</div>
		</div>
		<button class="button-redirect">
			{{
				newsletter.redirectionButtonText.trim() !== '' ? newsletter.redirectionButtonText : $t('controlPanel.landingPage.exampleButtonRedirect')
			}}
		</button>
	</div>
</template>

<script>
import {PLATFORMS} from "@/common/utils/constants";

export default {
	name: "NewsletterTemplate",
	props: {
		newsletter: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			PLATFORMS: PLATFORMS
		}
	}
}
</script>

<style lang="scss" scoped>
@import "@/common/assets/css/_variables.scss";

.newsletter {
	background-color: $newsletter-container-background;
	display: flex;
	flex-direction: row;
	height: 100%;
	flex-basis: 97%;
	padding: 1vw;
	border-radius: 4px;
	gap: 8px;
	min-height: 60px;
	max-width: 1200px;

	@media (max-width: $tablet) {
		flex-basis: 94%;
	}

	@media (max-width: $mobile) {
		flex-basis: 100%;
		padding: 10px;
		flex-wrap: wrap;
	}

	&:hover {
		background: $newsletter-hover-background;
	}

	.content-newsletter {
		display: flex;
		flex-direction: column;
		width: 100%;
		justify-content: space-between;
		gap: 0.5vh;

		div {
			display: flex;
			flex-direction: row;
			gap: 1%;
			width: 100%;
			justify-content: flex-start;

			@media (max-width: $mobile) {
				gap: 5%;
				flex-wrap: wrap;
			}

			p {
				margin: 0;
				font-family: "Roboto", sans-serif;
				font-size: 1.3vh;
				font-weight: 400;
				line-height: 2vh;
				letter-spacing: 0;
			}

			.content-topic {
				color: $newsletter-type-color;
				padding: 0 5px;
				border-radius: 2px;
				text-transform: capitalize;
			}

			.drc-title {
				color: $color-hover-button;
			}

			.gop-title {
				color: $gop-blue;
			}

			.drc-topic {
				background: $color-hover-button;
			}

			.gop-topic {
				background: $gop-blue;
			}
		}

		.message {
			font-size: 1.5vh;
			font-weight: 400;
			line-height: 2vh;
			letter-spacing: 0.38px;
		}
	}

	.button-redirect {
		height: fit-content;
		padding: 1px 10px;
		align-self: center;
		font-family: Roboto, serif;
		font-size: 1.2vh;
		font-weight: 600;
		line-height: 3vh;
		color: $color-white-light;
		white-space: nowrap;
		cursor: pointer;
		background: none;
		border: 1px solid $newsletter-button-text;

		@media (max-width: $mobile) {
			white-space: normal;
		}
	}
}
</style>
